import React from 'react';
import styled from 'styled-components';
import colors from '../styles/Colors';

const PRESENTS_URL = 'https://www.voxxypresents.com';

const FooterContainer = styled.footer`
  background-color: ${colors.background};
  padding: clamp(3rem, 6vw, 4rem) 1.5rem;
  margin-top: auto;
  border-top: 1px solid ${colors.borderDark};
`;

const FooterInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const TopRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 2rem;
  align-items: start;
`;

const BrandColumn = styled.div`
  grid-column: span 2;
  min-width: 220px;
  padding-left: 1rem;
  padding-right: 2rem;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.75rem;
`;

const BrandName = styled.h3`
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  background: linear-gradient(to right, ${colors.gradient.start}, ${colors.gradient.end});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const BrandDescription = styled.p`
  font-size: 0.95rem;
  line-height: 1.6;
  color: ${colors.textMuted};
  margin: 0;
  max-width: 420px;
`;

const ColumnHeading = styled.h4`
  font-size: 0.95rem;
  font-weight: 600;
  margin-bottom: 1.25rem;
  color: ${colors.textSecondary};
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const LinkList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  row-gap: 0.75rem;
  column-gap: 1rem;
`;

const FooterLink = styled.a`
  display: inline-block;
  color: ${colors.textMuted};
  font-size: 0.95rem;
  text-decoration: none;
  transition: all 0.2s ease;
  padding: 0.25rem 0;
  border-bottom: 2px solid transparent;

  &:hover {
    color: ${colors.secondaryButton};
    border-bottom-color: ${colors.secondaryButton};
  }

  &:focus {
    outline: none;
    border-radius: 4px;
    box-shadow: 0 0 0 2px ${colors.focus}40;
  }
`;

const BottomRow = styled.div`
  border-top: 1px solid ${colors.borderDark};
  padding-top: 1rem;
  text-align: center;
`;

const Copyright = styled.p`
  font-size: 0.75rem;
  color: ${colors.textMuted};
  margin: 0;
`;

export default function Footer() {
  return (
    <FooterContainer>
      <FooterInner>
        <TopRow>
          <BrandColumn>
            <BrandName>Voxxy</BrandName>
            <BrandDescription>
              Event management software for producers of recurring events — art markets, pop-ups, craft fairs, and farmers markets.
            </BrandDescription>
          </BrandColumn>

          <div>
            <ColumnHeading>Product</ColumnHeading>
            <LinkList>
              <li><FooterLink href={PRESENTS_URL} target="_blank" rel="noopener noreferrer">Get Started</FooterLink></li>
              <li><FooterLink href={`${PRESENTS_URL}/#contact`} target="_blank" rel="noopener noreferrer">Contact</FooterLink></li>
            </LinkList>
          </div>

          <div>
            <ColumnHeading>Legal</ColumnHeading>
            <LinkList>
              <li><FooterLink href={`${PRESENTS_URL}/legal/terms`} target="_blank" rel="noopener noreferrer">Terms of Service</FooterLink></li>
              <li><FooterLink href={`${PRESENTS_URL}/legal/privacy`} target="_blank" rel="noopener noreferrer">Privacy Policy</FooterLink></li>
              <li><FooterLink href={`${PRESENTS_URL}/legal/cookies`} target="_blank" rel="noopener noreferrer">Cookie Policy</FooterLink></li>
            </LinkList>
          </div>
        </TopRow>

        <BottomRow>
          <Copyright>
            &copy; 2025 Voxxy AI, Inc. All rights reserved.
          </Copyright>
        </BottomRow>
      </FooterInner>
    </FooterContainer>
  );
}
